// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/JustMeAgainDownHere-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --notch-inset-top: 0px;
    --notch-inset-right: 0px;
    --notch-inset-bottom: 0px;
    --notch-inset-left: 0px;
}

@font-face {
    font-family: 'JustMeAgainDownHere';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

/* Clear Style */
body, h1, h2, h3, p, ul, ol, li {
    margin: 0;
    padding: 0;
}

/* Game Container Style */
body {
    font-family: 'JustMeAgainDownHere', 'Arial', sans-serif;
    overflow: hidden;
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background-color: #fff;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;

    touch-action: none;


    #into{
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
}

body.ios, body.android{
    height: 100vh;
    width: 100vw;


    #into{
        margin: max(env(safe-area-inset-top), var(--notch-inset-top)) max(env(safe-area-inset-right), var(--notch-inset-right)) max(env(safe-area-inset-bottom), var(--notch-inset-bottom)) max(env(safe-area-inset-left), var(--notch-inset-left));
        height: calc(100% - max(env(safe-area-inset-top), var(--notch-inset-top)) - max(env(safe-area-inset-bottom), var(--notch-inset-bottom)));
        width: calc(100% - max(env(safe-area-inset-right), var(--notch-inset-right)) - max(env(safe-area-inset-left), var(--notch-inset-left)));
    }
}
`, "",{"version":3,"sources":["webpack://./assets/core.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,+DAAoE;AACxE;;AAEA,gBAAgB;AAChB;IACI,SAAS;IACT,UAAU;AACd;;AAEA,yBAAyB;AACzB;IACI,uDAAuD;IACvD,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,sBAAsB;;IAEtB,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;;IAEjB,kBAAkB;;;IAGlB;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;;;IAGZ;QACI,2OAA2O;QAC3O,wIAAwI;QACxI,uIAAuI;IAC3I;AACJ","sourcesContent":[":root {\n    --notch-inset-top: 0px;\n    --notch-inset-right: 0px;\n    --notch-inset-bottom: 0px;\n    --notch-inset-left: 0px;\n}\n\n@font-face {\n    font-family: 'JustMeAgainDownHere';\n    src: url('fonts/JustMeAgainDownHere-Regular.ttf') format('truetype');\n}\n\n/* Clear Style */\nbody, h1, h2, h3, p, ul, ol, li {\n    margin: 0;\n    padding: 0;\n}\n\n/* Game Container Style */\nbody {\n    font-family: 'JustMeAgainDownHere', 'Arial', sans-serif;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #fff;\n\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    touch-action: none;\n\n\n    #into{\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n    }\n}\n\nbody.ios, body.android{\n    height: 100vh;\n    width: 100vw;\n\n\n    #into{\n        margin: max(env(safe-area-inset-top), var(--notch-inset-top)) max(env(safe-area-inset-right), var(--notch-inset-right)) max(env(safe-area-inset-bottom), var(--notch-inset-bottom)) max(env(safe-area-inset-left), var(--notch-inset-left));\n        height: calc(100% - max(env(safe-area-inset-top), var(--notch-inset-top)) - max(env(safe-area-inset-bottom), var(--notch-inset-bottom)));\n        width: calc(100% - max(env(safe-area-inset-right), var(--notch-inset-right)) - max(env(safe-area-inset-left), var(--notch-inset-left)));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
